import React, { useState } from "react";
import MyDropdown from "../../../Common/my-dropdown/my-dropdown-new.component";
import ColorPicker from "../../../../common/color-picker/color-picker.component";
import styles from "./index.module.scss";
import cn from "../../../../Utils/class-names.utils";
import SelectArrowIcon from "../../../icons/select-arrow.icon";

interface ColorPickerDropdownProps {
  color?: string;
  isDisabled?: boolean;
  popperConfig?: any;
  renderOnMount?: boolean;
  fetchDataOnMount?: boolean;
  onColorSelect: (color: string) => void;
}

const ColorPickerDropdown: React.FC<ColorPickerDropdownProps> = ({
  color,
  isDisabled,
  popperConfig,
  renderOnMount,
  fetchDataOnMount,
  onColorSelect,
}) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);

  const handleColorSelect = (selectedColor: string) => {
    onColorSelect(selectedColor);
    document.body.click();
  };

  const handleColorPickerToggle = (isOpen: boolean) => {
    setIsColorPickerOpen(isOpen);
  };

  return (
    <MyDropdown
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      onToggle={handleColorPickerToggle}
    >
      <MyDropdown.Toggle
        className={styles.colorPickerToggle}
        hideArrow={true}
        disabled={isDisabled}
      >
        <div className={styles.colorCircle} style={{ backgroundColor: color }} />
        <div
          className={cn("align-items-center justify-content-center category-color-arrow")}
          style={{ width: "24px", height: "24px" }}
        >
          <SelectArrowIcon
            fill="#9499aa"
            width="10px"
            className={cn({
              rotate180: isColorPickerOpen,
            })}
          />
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu className={styles.colorPickerMenu} popperConfig={popperConfig} renderOnMount={renderOnMount}>
        <ColorPicker
          defaultColor={color}
          themesColors={[]}
          colorValidation={() => true}
          onSelect={handleColorSelect}
          fetchDataOnMount={fetchDataOnMount}
        />
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default ColorPickerDropdown;

